import { FontWeights } from '@newcore/ui/enums/font-weights';
import { DisplaySizes } from '@newcore/ui/enums/typography-display-sizes';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Display, Text } from '@newcore/ui/typography';

export function NotFoundPage() {
  return (
    <div className='min-h-screen flex items-center justify-center bg-primary p-4'>
      <div className='text-center'>
        <Display
          as='h1'
          size={DisplaySizes.MD}
          weight={FontWeights.BOLD}
          className='text-tertiary mb-4'
        >
          404
        </Display>
        <Text as='p' size={TextSizes.LG} className='text-tertiary'>
          Page Not Found
        </Text>
        <Text as='p' className='text-tertiary mt-2'>
          Example: app.spark.dev/acme/dashboard
        </Text>
      </div>
    </div>
  );
}
